// Mock data for Travelsera

export const heroBanner = 'https://images.pexels.com/photos/1802255/pexels-photo-1802255.jpeg?auto=compress&cs=tinysrgb&w=1920';

export const domesticChips = [
  { name: 'Darjeeling', slug: 'darjeeling' },
  { name: 'Goa', slug: 'goa' },
  { name: 'Andaman', slug: 'andaman' },
  { name: 'Himachal', slug: 'himachal' },
  { name: 'Kashmir', slug: 'kashmir' },
  { name: 'Kerala', slug: 'kerala' },
  { name: 'Rajasthan', slug: 'rajasthan' },
  { name: 'Sikkim', slug: 'sikkim' },
];

export const internationalChips = [
  { name: 'Bhutan', slug: 'bhutan' },
  { name: 'Indonesia', slug: 'indonesia' },
  { name: 'Malaysia', slug: 'malaysia' },
  { name: 'Maldives', slug: 'maldives' },
  { name: 'Singapore', slug: 'singapore' },
  { name: 'Thailand', slug: 'thailand' },
  { name: 'Vietnam', slug: 'vietnam' },
];

export const benefits = [
  {
    icon: 'Award',
    title: '18+ years of Experience',
    desc: 'With the best professionals in the industry, you are in safe hands!',
    tone: 'blue',
  },
  {
    icon: 'Globe2',
    title: '500+ Destinations',
    desc: 'From Sikkim & Darjeeling to Thailand and Singapore\u2014crafted journeys that inspire you to travel more and discover endlessly.',
    tone: 'yellow',
  },
  {
    icon: 'BadgeIndianRupee',
    title: 'Best Price In The Industry',
    desc: 'Cheapest price is not the best price. We prefer to provide best quality services at best price.',
    tone: 'blue',
  },
];

export const internationalTours = [
  {
    id: '118575',
    title: 'Splendors Of Phuket & Krabi',
    duration: '4 Nights, 5 Days',
    itinerary: '2N Krabi, 2N Phuket',
    price: 15000,
    image: 'https://images.pexels.com/photos/1450353/pexels-photo-1450353.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'beach',
    destination: 'thailand',
    themes: ['beach', 'family', 'honeymoon'],
  },
  {
    id: '118877',
    title: 'Bali - Nusa Penida',
    duration: '6 Nights, 7 Days',
    itinerary: '3N Kuta, 1N Nusa Penida, 2N Ubud',
    price: 29022,
    image: 'https://images.pexels.com/photos/1802183/pexels-photo-1802183.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'beach',
    destination: 'indonesia',
    themes: ['beach', 'honeymoon', 'adventure'],
  },
  {
    id: '118522',
    title: 'Twin City Delights \u2013 Singapore & Malaysia',
    duration: '6 Nights, 7 Days',
    itinerary: '3N Kuala Lumpur, 3N Singapore',
    price: 46196,
    image: 'https://images.pexels.com/photos/302769/pexels-photo-302769.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'city',
    destination: 'singapore',
    themes: ['family'],
  },
  {
    id: '118527',
    title: 'Best Of Vietnam',
    duration: '7 Nights, 8 Days',
    itinerary: '1N Hanoi, 1N Ha Long, 3N Da Nang +1',
    price: 54240,
    image: 'https://images.pexels.com/photos/2166711/pexels-photo-2166711.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'beach',
    destination: 'vietnam',
    themes: ['family', 'beach', 'adventure'],
  },
  {
    id: '118600',
    title: 'Magical Maldives Escape',
    duration: '3 Nights, 4 Days',
    itinerary: '3N Male Water Villa',
    price: 52000,
    image: 'https://images.pexels.com/photos/1450360/pexels-photo-1450360.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'beach',
    destination: 'maldives',
    themes: ['honeymoon', 'beach'],
  },
  {
    id: '118611',
    title: 'Bhutan Cultural Trail',
    duration: '5 Nights, 6 Days',
    itinerary: '2N Thimphu, 2N Paro, 1N Punakha',
    price: 38500,
    image: 'https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'mountain',
    destination: 'bhutan',
    themes: ['family', 'adventure'],
  },
];

export const indiaTours = [
  {
    id: '117866',
    title: 'Katra Vaishno Devi Summer Package',
    duration: '4 Nights, 5 Days',
    itinerary: '3N Katra, 1N Patnitop',
    price: 12441,
    image: 'https://images.pexels.com/photos/210012/pexels-photo-210012.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'temple',
    destination: 'kashmir',
    themes: ['pilgrimage', 'family'],
  },
  {
    id: '116781',
    title: 'Himalayan Gateway - Deluxe',
    duration: '5 Nights, 6 Days',
    itinerary: '3N Gangtok, 2N Darjeeling',
    price: 21505,
    image: 'https://images.pexels.com/photos/1450082/pexels-photo-1450082.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'mountain',
    destination: 'sikkim',
    themes: ['family', 'adventure', 'honeymoon'],
  },
  {
    id: '114562',
    title: 'Leh Package \u2013 Ex Leh Airport',
    duration: '6 Nights, 7 Days',
    itinerary: '2N Leh, 2N Nubra, 1N Pangong +1',
    price: 22885,
    image: 'https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'mountain',
    destination: 'ladakh',
    themes: ['adventure'],
  },
  {
    id: '116808',
    title: 'Mystic Mountains - Deluxe',
    duration: '6 Nights, 7 Days',
    itinerary: '2N Gangtok, 2N Pelling, 2N Darjeeling',
    price: 27485,
    image: 'https://images.pexels.com/photos/572897/pexels-photo-572897.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'mountain',
    destination: 'sikkim',
    themes: ['family', 'adventure'],
  },
  {
    id: '116861',
    title: 'Himalayan Bliss - Deluxe',
    duration: '7 Nights, 8 Days',
    itinerary: '3N Gangtok, 2N Pelling, 2N Darjeeling',
    price: 31510,
    image: 'https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'mountain',
    destination: 'sikkim',
    themes: ['family', 'adventure', 'honeymoon'],
  },
  {
    id: '118269',
    title: 'Spiti Valley Offbeat Destination 2026',
    duration: '9 Nights, 10 Days',
    itinerary: '1N Narkanda, 2N Sangla, 1N Tabo +3',
    price: 33235,
    image: 'https://images.pexels.com/photos/347573/pexels-photo-347573.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'mountain',
    destination: 'himachal',
    themes: ['adventure'],
  },
  {
    id: '116846',
    title: 'Mystic Mountains - Premium',
    duration: '6 Nights, 7 Days',
    itinerary: '2N Gangtok, 2N Pelling, 2N Darjeeling',
    price: 34960,
    image: 'https://images.pexels.com/photos/2440024/pexels-photo-2440024.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'mountain',
    destination: 'sikkim',
    themes: ['family', 'honeymoon'],
  },
  {
    id: '116869',
    title: 'Himalayan Bliss - Premium',
    duration: '7 Nights, 8 Days',
    itinerary: '3N Gangtok, 2N Pelling, 2N Darjeeling',
    price: 50025,
    image: 'https://images.pexels.com/photos/1287145/pexels-photo-1287145.jpeg?auto=compress&cs=tinysrgb&w=800',
    fbType: 'mountain',
    destination: 'sikkim',
    themes: ['family', 'honeymoon'],
  },
];

export const themes = [
  { name: 'Honeymoon', slug: 'honeymoon', image: 'https://images.pexels.com/photos/842711/pexels-photo-842711.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'couple', tagline: 'Romance, wrapped in unforgettable places', blurb: 'Sun-kissed beaches, private villas and candle-lit dinners \u2014 our honeymoon collections are designed for couples starting their forever.' },
  { name: 'Adventure', slug: 'adventure', image: 'https://images.pexels.com/photos/2422915/pexels-photo-2422915.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'adventure', tagline: 'Trek, ride, raft, repeat', blurb: 'From Ladakh\u2019s high passes to Bali\u2019s active volcanoes, our adventure packages are for travellers who like their memories with a heartbeat.' },
  { name: 'Wildlife', slug: 'wildlife', image: 'https://images.pexels.com/photos/667205/pexels-photo-667205.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'wildlife', tagline: 'Where the wild things still live', blurb: 'Safaris, national parks and up-close encounters guided by naturalists who know each animal by name.' },
  { name: 'Beach', slug: 'beach', image: 'https://images.pexels.com/photos/1533720/pexels-photo-1533720.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'beach', tagline: 'Warm sand, cold drinks, blue horizons', blurb: 'Turquoise waters, coral reefs and beach clubs \u2014 our best coastal escapes across Southeast Asia, Maldives and India.' },
  { name: 'Family', slug: 'family', image: 'https://images.pexels.com/photos/1157393/pexels-photo-1157393.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'family', tagline: 'Trips the whole family will remember', blurb: 'Kid-friendly hotels, easy logistics and activities that keep everyone from grandparents to toddlers genuinely delighted.' },
  { name: 'Pilgrimage', slug: 'pilgrimage', image: 'https://images.pexels.com/photos/2846215/pexels-photo-2846215.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'temple', tagline: 'Journeys of faith and peace', blurb: 'Vaishno Devi, Kedarnath, Char Dham and more \u2014 comfortable, respectful and well-organised spiritual journeys.' },
  { name: 'Cruise', slug: 'cruise', image: 'https://images.pexels.com/photos/2144326/pexels-photo-2144326.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'beach', tagline: 'Wake up in a new port every day', blurb: 'Modern cruise ships across Singapore, Malaysia and India \u2014 balcony cabins, world cuisine and shore excursions included.' },
];

export const trendingCountries = [
  { name: 'Vietnam', slug: 'vietnam', image: 'https://images.pexels.com/photos/2166711/pexels-photo-2166711.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'beach', tagline: 'Where street food meets postcard bays', blurb: 'From the lantern-lit lanes of Hoi An to the emerald karsts of Ha Long Bay, Vietnam packs unforgettable variety into every trip.' },
  { name: 'United Arab Emirates', slug: 'uae', image: 'https://images.pexels.com/photos/1470502/pexels-photo-1470502.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'city', tagline: 'Skylines, desert dunes and world-class luxury', blurb: 'Dubai and Abu Dhabi combine futuristic architecture, luxury shopping, gold souks and desert safaris in one seamless getaway.' },
  { name: 'Thailand', slug: 'thailand', image: 'https://images.pexels.com/photos/1450353/pexels-photo-1450353.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'beach', tagline: 'Islands, temples and the friendliest smiles', blurb: 'Phuket, Krabi, Koh Samui and Bangkok \u2014 a country that never gets old, whether you visit once or every year.' },
  { name: 'Singapore', slug: 'singapore', image: 'https://images.pexels.com/photos/302769/pexels-photo-302769.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'city', tagline: 'A city that works like a dream', blurb: 'Universal Studios, Gardens by the Bay, Sentosa beaches and hawker food heaven \u2014 the perfect first international trip.' },
  { name: 'Bhutan', slug: 'bhutan', image: 'https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'mountain', tagline: 'The kingdom of gross national happiness', blurb: 'Ancient monasteries, prayer flag mountain passes and a pace of life that will slow you down in the best way.' },
  { name: 'Indonesia', slug: 'indonesia', image: 'https://images.pexels.com/photos/1802183/pexels-photo-1802183.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'beach', tagline: 'Bali and beyond', blurb: 'Rice terraces of Ubud, cliffside temples of Uluwatu and the untouched beaches of Nusa Penida make Indonesia endlessly returnable.' },
  { name: 'Maldives', slug: 'maldives', image: 'https://images.pexels.com/photos/1450360/pexels-photo-1450360.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'beach', tagline: 'Overwater villas and coral gardens', blurb: 'Just a few hours from India, the Maldives is that once-in-a-lifetime escape \u2014 for honeymoons, milestone birthdays and pure blue water.' },
];

export const trendingStates = [
  { name: 'Sikkim', slug: 'sikkim', image: 'https://images.pexels.com/photos/1287145/pexels-photo-1287145.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'mountain', tagline: 'India\u2019s greenest, cleanest, chillest state', blurb: 'Gangtok, Pelling, Lachung and Yumthang \u2014 monasteries, mountain lakes and momos at every corner. Sikkim is easy to love.' },
  { name: 'Kashmir', slug: 'kashmir', image: 'https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'mountain', tagline: 'Paradise on earth, and it lives up to the phrase', blurb: 'Shikara rides on Dal Lake, tulip gardens in April, and snow-dusted Gulmarg in winter \u2014 Kashmir changes with the seasons.' },
  { name: 'Goa', slug: 'goa', image: 'https://images.pexels.com/photos/1533720/pexels-photo-1533720.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'beach', tagline: 'Sun, sand and sundowners', blurb: 'North Goa for beach clubs, South Goa for palm-lined quiet. Every kind of holiday, one small state.' },
  { name: 'Rajasthan', slug: 'rajasthan', image: 'https://images.pexels.com/photos/3581916/pexels-photo-3581916.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'temple', tagline: 'Palaces, dunes and heritage on every corner', blurb: 'Jaipur, Udaipur, Jodhpur, Jaisalmer \u2014 India\u2019s most photogenic circuit, best done between October and March.' },
  { name: 'Andaman', slug: 'andaman', image: 'https://images.pexels.com/photos/1450360/pexels-photo-1450360.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'beach', tagline: 'Turquoise water without the passport', blurb: 'Havelock\u2019s Radhanagar Beach, Neil Island\u2019s coral gardens \u2014 tropical bliss right at home.' },
  { name: 'Kerala', slug: 'kerala', image: 'https://images.pexels.com/photos/1450082/pexels-photo-1450082.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'beach', tagline: 'God\u2019s own country, calmly explored', blurb: 'Backwaters of Alleppey, tea gardens of Munnar and beaches of Varkala \u2014 Kerala is the softest way to see India.' },
  { name: 'Ladakh', slug: 'ladakh', image: 'https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'mountain', tagline: 'A cold desert unlike anywhere else in India', blurb: 'Pangong Lake, Nubra Valley and monasteries at 14,000 feet \u2014 the trip of a lifetime for anyone who loves mountains.' },
  { name: 'Himachal', slug: 'himachal', image: 'https://images.pexels.com/photos/347573/pexels-photo-347573.jpeg?auto=compress&cs=tinysrgb&w=1600', fbType: 'mountain', tagline: 'The mountains you dreamed of as a kid', blurb: 'Manali, Kasol, Shimla, Spiti \u2014 valley after valley of forests, rivers and small hill towns. Perfect for both first-timers and repeat travellers.' },
];

export const partners = [
  'Udaan', 'Mayfair', 'Taj', 'Ramada', 'Lemon Tree', 'Hyatt', 'Novotel', 'Sterling',
  'Ginger', 'Fortune', 'Oberoi', 'Sarovar', 'Lalit', 'Radisson', 'Marriott', 'ITC',
  'Leela', 'Yashshreee', 'Summit', 'Jain', 'Bloomrooms', 'Club Mahindra', 'La Manila', 'The Fern',
];

export const whyUs = [
  { icon: 'ShieldCheck', title: 'Safe & Secure', desc: 'Purchase with Confidence: Safe & Secure Bookings' },
  { icon: 'CalendarCheck', title: 'Easy Booking', desc: 'We offer easy and convenient flight bookings with attractive offers.' },
  { icon: 'BadgePercent', title: 'Lowest Price', desc: 'We ensure low rates on hotel reservation, holiday packages and on flight tickets.' },
  { icon: 'Headphones', title: '24/7 Customer Support', desc: 'Get assistance 24/7 on any kind of travel related query. We are happy to assist you.' },
];

export const testimonials = [
  {
    name: 'Ananya Sharma',
    role: 'Honeymooner, Bali',
    avatar: 'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=200',
    rating: 5,
    text: 'Travelsera made our Bali honeymoon absolutely dreamy. Every hotel, every transfer, every experience felt handpicked for us. Truly stress-free travel!',
  },
  {
    name: 'Rohit & Family',
    role: 'Family Trip, Sikkim',
    avatar: 'https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=200',
    rating: 5,
    text: 'Took my kids to Gangtok and Darjeeling. The itinerary was perfectly paced, the driver was polite and knowledgeable. My children still talk about the toy train!',
  },
  {
    name: 'Priya Menon',
    role: 'Solo Traveller, Vietnam',
    avatar: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=200',
    rating: 5,
    text: 'As a solo female traveller, safety and reliability matter. Travelsera nailed both. Ha Long Bay cruise and Da Nang lantern nights were unforgettable.',
  },
  {
    name: 'Arjun Kapoor',
    role: 'Adventure Seeker, Ladakh',
    avatar: 'https://images.pexels.com/photos/1300402/pexels-photo-1300402.jpeg?auto=compress&cs=tinysrgb&w=200',
    rating: 5,
    text: 'Pangong, Nubra, Khardung La \u2014 the Ladakh package covered everything. High-altitude support and oxygen readiness were a lifesaver. Highly recommend!',
  },
  {
    name: 'Meera Iyer',
    role: 'Group Tour, Thailand',
    avatar: 'https://images.pexels.com/photos/774095/pexels-photo-774095.jpeg?auto=compress&cs=tinysrgb&w=200',
    rating: 5,
    text: 'Went with 8 friends to Phuket and Krabi. The coordination was flawless. Speedboat to Phi Phi and Krabi cliff sunset \u2014 pure magic.',
  },
  {
    name: 'Sanjay Verma',
    role: 'Corporate Retreat, Singapore',
    avatar: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=200',
    rating: 5,
    text: 'Organised a 30-person corporate retreat. Every detail from airport pickup to Sentosa passes was on point. Our team is asking when the next one is!',
  },
];
